module.exports = __webpack_public_path__ + "img/image-01.9e226828.jpg";